import SearchNothingFoundIcon from '/public/icons/search-nothing-found.svg';

export const NothingFoundState = () => {
  return (
    <div className="flex flex-col items-center max-md:text-center">
      <SearchNothingFoundIcon viewBox="0 0 80 80" className="mb-[40px] max-md:h-15 max-md:w-15" />
      <h3 className="light mb-2 text-black max-md:!text-xl max-md:!leading-[110%]">No matching results</h3>
      <p className="text-body-regular text-black max-md:!text-sm max-md:!leading-[150%]">
        We couldn’t find any matches for your search.
      </p>
      <p className="text-body-regular text-black max-md:!text-sm max-md:!leading-[150%]">
        Try a different keyword or check your spelling.
      </p>
    </div>
  );
};
